export default __webpack_public_path__ + "static/media/toka-girl.eac6a43e.png";